import { client, handleRequestBody } from "./client.ts";

export interface CepAddress {
	street: string;
	neighborhood: string;
	city: string;
	state: string;
	zipcode: string;
	lat?: number;
	lng?: number;
}

interface CepResponse {
	address: CepAddress;
}

// lookupCep resolves a CEP to its structured address via the API's BrasilAPI
// proxy. Coordinates are present only when BrasilAPI geocoded the CEP.
export async function lookupCep(cep: string): Promise<CepAddress> {
	const digits = cep.replace(/\D/g, "");
	const { address } = await handleRequestBody(() =>
		client.get<CepResponse>(`/cep/${digits}`),
	);
	return address;
}
